import Error from "./ErrorContainer";

export default {
  Error
};
